import React, {useEffect, useState} from 'react';
import CircularProgress from "@mui/material/CircularProgress";
import {useSelector} from "react-redux";
import Fade from "@mui/material/Fade";
import { objectIsNotEmpty } from "../../Helpers/ObjectHelper";

const InfiniteScrollZone = (props) => {
    const {strings} = useSelector(state => state.module['VISITORS'].common);

    let [loadingThrottled, setLoadingThrottled] = useState(false);

    useEffect(() => {
        possiblyLoadMoreResults();
    }, [props.containerScrollTop, props.containerHeight])

    const possiblyLoadMoreResults = () => {
        if (!props.visitsAreLoading
            && !loadingThrottled
            && props.hasMoreRecords
            && props.containerScrollTop
            && props.containerHeight
            && props.containerScrollTop >= (props.containerHeight - 30)
        ) {
            props.onLoad();
            setLoadingThrottled(true);
            setTimeout(() => { setLoadingThrottled(false) }, 250)
        }
    }

    const getNoMoreRecordsMessage = () => {
        if (objectIsNotEmpty(props.filters)) {
            return 'No more results for current filter settings';
        }

        if (strings?.noMoreRecordsMessage) {
            return strings?.noMoreRecordsMessage
        }

        return '';
    }

    const getMessage = () => {
        if (!props.hasMoreRecords) {
            let noMoreRecordsMessage = getNoMoreRecordsMessage();

            if (noMoreRecordsMessage) {
                return <small>{noMoreRecordsMessage}</small>
            }
            return <small></small>
        } else {
            return (<>
                <span className="message">Loading More</span>
                {/*<CircularProgress/>*/}
            </>);
        }
    }

    return (
        <Fade in={props.isLoading || !props.hasMoreRecordsAtEnd} timeout={500}>
            <div style={{backgroundColor: 'transparent', padding: '2rem 0 2rem', minHeight: '95px'}}>
                <div className="loading-info">
                    {getMessage()}
                </div>
            </div>
        </Fade>
    );
}

export default InfiniteScrollZone;
